/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CompletarRegistroForm from './CompletarRegistroForm';
import * as validations from '../../validations/validations';
import * as usuarioActions from '../../actions/usuarioActions';
import * as roleActions from '../../actions/roleActions';
import withRouter from '../common/withRouter';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import { message } from 'antd';
import dayjs from 'dayjs';


/////FORMULARIO////////////////////////////////////////
import * as formularioActions from '../../actions/formularioActions';
import * as preguntarespuestaActions from '../../actions/preguntarespuestaActions';
import {Auth} from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react'
///////////////////////////////////////////////////////////

class ManageCompletarRegistroForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			usuario:{},
            
            ////////////FORMULARIO//////
            datosGenerales:{},
            formulario:[],
            preguntaRespuesta:[]
            ///////////////////////////
		};
		
	}
    
    async checkUser(){
        try{
            const data =await Auth.currentUserPoolUser();
            const userInfo={username:data.username, ...data.attributes};
            this.setState({"userInfo": userInfo});
        }catch (err){console.log('error:', err)}
    }
    
    componentDidMount(){
        this.checkUser();
        let id=this.props.id;
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        ///////////////////////// FORMULARIO DINAMICO //////////////////////////
        
        /*
        this.props.formularioActions.getFormulario(1, this.props.user).then(formulario=>{
                let datos = this.state.formulario;
                datos.push(formulario);
                this.setState({"formulario":datos});
           })
            .catch(error=>{
              toastr.error(error);
            });
        
        this.props.preguntarespuestaActions.getPreguntaRespuesta(this.props.user).then(respuestas=>{
                let datosGenerales = this.state.datosGenerales;
                
                for(let i=0; i<respuestas.length;i++){
                    if(respuestas[i].tipo == 'input' || respuestas[i].tipo == 'textArea'){
                        datosGenerales[respuestas[i].idPregunta]=respuestas[i].textoRespuesta;
                    } else{
                        if(respuestas[i].consecutivoRespuesta==0){
                            datosGenerales[respuestas[i].idPregunta]=respuestas[i].value;
                        }else{
                            datosGenerales[respuestas[i].idPregunta+'_'+respuestas[i].idRespuesta]=1;
                        }    
                    }   
                }
                this.setState({"datosGenerales":datosGenerales});
           })
            .catch(error=>{
              toastr.error(error);
            });
        */
        /////////////////////////////////////////////////////////////////////////////////
        
        
        let pageInfo={ 
            page:'usuario', 
            idioma:this.props.idioma     
        }; 
        
        this.props.roleActions.getRoleCombo( this.props.user).then( usuario=>{
                
           })
            .catch(error=>{
              toastr.error(error);
            });
        
        
        
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
        }).catch(error=>{ 
            toastr.error(error); 
        }); 
        
         
            
           this.props.usuarioActions.getInfoPerfil(this.props.user).then( usuario=>{
              
               this.setState({"usuario":usuario});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
         
     
    }
    
    
    ///////////////////////////////////////FORMULARIO DINAMICO/////////////////////////////////////////
    
    buscarSeccionFormulario=(formulario, data)=>{
        let index;
        let nombre;
        if(data.type=='checkbox' || data.type=='file'){
            nombre=data.name.split('_');
        }
        
        for(let i=0;i<formulario.length;i++){
            if(data.type=='checkbox' || data.type=='file'){
                index = formulario[i].pregunta.findIndex(pregunta=>pregunta.id==nombre[0]);
            }else{
                index = formulario[i].pregunta.findIndex(pregunta=>pregunta.id==data.name);
            }
            if(index!=-1){
                return formulario[i].pregunta[index];        
                break;
            }
        }
    }
    
    handleRespuestaPregunta=(event,data)=>{
        
        let formulario = this.state.formulario;
        let preguntaRespuesta=this.state.preguntaRespuesta;
        let seccion = this.buscarSeccionFormulario(formulario, data);
        let resp={};
        let index;
        let nombre;
        let indexPregunta;
        
        if(data.type=='checkbox' || data.type=='file'){
            nombre=data.name.split('_');
            indexPregunta = preguntaRespuesta.findIndex(e=>e.idPregunta==nombre[0] && e.idRespuesta==nombre[1]);
        }else{
            indexPregunta = preguntaRespuesta.findIndex(e=>e.idPregunta==seccion.id);
        }
        
        
    
        if(seccion.respuestaList.length>0){
            if(indexPregunta!=-1){        
                if(data.type=='checkbox' || data.type=='file'){
                    preguntaRespuesta[indexPregunta].borrar = !data.checked;
                }else{
                    index = seccion.respuestaList.findIndex(opciones=>opciones.value==data.value);
                    preguntaRespuesta[indexPregunta].idRespuesta = seccion.respuestaList[index].id;
                }    
            }else{
                
                if(data.type=='checkbox' || data.type=='file'){
                    nombre=data.name.split('_');
                    resp.idPregunta = nombre[0];  
                }else{
                    resp.idPregunta = seccion.id;
                }
                

                
                index = seccion.respuestaList.findIndex(opciones=>opciones.value==data.value);
                resp.idRespuesta = seccion.respuestaList[index].id;
                resp.usuarioEmail = this.state.userInfo.email;  
                resp.consecutivoRespuesta = seccion.respuestaList[index].value;  
                resp.tipo=seccion.tipo;
                resp.borrar=!data.checked;
                preguntaRespuesta.push(resp);
                
            }    
        }else{
            
            if(indexPregunta!=-1){        
                preguntaRespuesta[indexPregunta].textoRespuesta = data.value;
            }else{
                resp.idPregunta = seccion.id;
                resp.textoRespuesta = data.value;
                resp.usuarioEmail = this.state.userInfo.email;
                resp.tipo=seccion.tipo;
                preguntaRespuesta.push(resp);
            }
            
            
        }
        this.setState({preguntaRespuesta:preguntaRespuesta});
    }
    
    
    handleChangeFormulario=(event, data)=> {

        let datosGenerales = this.state.datosGenerales;
        let field= data.name;		
        let value;
        
        this.handleRespuestaPregunta(event,data);
        
        if(data.type == 'checkbox'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
       
        field=field.toString();
        field=field.split('.');

        if(field.length==1)
            datosGenerales[field[0]]= value;
        else{
             if(!datosGenerales[field[0]]){
                    datosGenerales[field[0]]={}
                }
            datosGenerales[field[0]][field[1]]= value;
        }
		
		
        this.setState({"datosGenerales": datosGenerales});
        
    }
    
    
    ///////////////////////////////////////////////////////////////////////////////////////////////////

    handleChange=(event, data)=> {

        let usuario = this.state.usuario;
        let field= data.name;		
        let value = data.value;
        
        if(data.type == 'checkbox'){
          if(data.checked){
                value = 1;
            }else{
                value = 2
            }
        }
        
        console.log(value);
        
        field=field.split('.');
		if(field.length==1)
      		usuario[field[0]]= value;
		else{
             if(!usuario[field[0]]){
                    usuario[field[0]]={}
                }
			usuario[field[0]][field[1]]= value;
		}
        
		
        this.setState({"usuario": usuario});
    }
    
    
    fechas=(fechasArreglo, fechasCadena)=>{
       
        let usuario = this.state.usuario;
        usuario.fechaNacimiento = fechasCadena;
        usuario.fechadayJS = fechasArreglo;
        this.setState({usuario:usuario});
    }
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let usuario=this.state.usuario;
              
        if(!validations.requerido(usuario.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(usuario.apellido)){
            errors.apellido=true;
            formIsValid=false;
        }
       
     
        if(!validations.requerido(usuario.telefono)){
            errors.telefono=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(usuario.profesion)){
            errors.profesion=true;
            formIsValid=false;
        }
        if(!validations.requerido(usuario.resumen)){
            errors.resumen=true;
            formIsValid=false;
        }
        if(!validations.requerido(usuario.empresa)){
            errors.empresa=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(usuario.idPais)){
            errors.idPais=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(usuario.numeroDocumento)){
            errors.numeroDocumento=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(usuario.tipoDocumentoId)){
            errors.tipoDocumentoId=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(usuario.rolEmpresa)){
            errors.rolEmpresa=true;
            formIsValid=false;
        }
        
        
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        let newState=Object.assign({}, this.state.usuario);
       
         newState.fechaNacimiento = dayjs(this.state.usuario.fechadayJS).format('DD/MM/YYYY');
        
        this.props.usuarioActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //message.success('This is a prompt message for success, and it will disappear in 10 seconds', 10);
            //this.props.history.push();
            this.props.navigate('/miespacio');
        });
        
        if(this.state.preguntaRespuesta.length>0){
            this.props.preguntarespuestaActions.save(this.state.preguntaRespuesta, this.props.user).then(() => {
                toastr.success("Registro guardado!!!.");
                //message.success('This is a prompt message for success, and it will disappear in 10 seconds', 10);
            });
        }    
        
    }
    
 
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        return (
              <Segment  style={margenes}>
                <CompletarRegistroForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.usuario}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    roleCombo={genericFormattedForDropdown(this.props.roleCombo)}

                    formulario={this.state.formulario}
                    datosGenerales={this.state.datosGenerales}
                    onChangeFormulario={this.handleChangeFormulario}
                    fechas={this.fechas}          
                />
            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){

    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            roleCombo:state.roleCombo,
            form:state.form,
            strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
            roleActions: bindActionCreators(roleActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch),
            formularioActions: bindActionCreators(formularioActions, dispatch),
            preguntarespuestaActions: bindActionCreators(preguntarespuestaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCompletarRegistroForm));